
const font_style = {
    namespaced: true,
    state: {
        bold: false,
        underline: false,
        italics: false
    },
    mutations: {
        SET_bold(state, val) {
            state.bold = val
        },
        SET_underline(state, val) {
            state.underline = val
        },
        SET_italics(state, val) {
            state.italics = val
        },

    }
};

export default font_style;



// WEBPACK FOOTER //
// ./src/vuex/modules/font_style.js